<app-compare-value [inputData]="formValue" (onChanged)="emitChange($event)" *ngIf="isCalculated"></app-compare-value>
<form [id]="formId" *ngIf="!isCalculated"></form>